"use strict";
import { uniq, includes } from 'lodash';
var util = require('./myutil.js');
var cleanids = require('./cleanids.js');
function clean (data) {
    function cleanOutLinksAndComponents(o) {
    }
    function cleanVariables(v) {
        (v || []).forEach(function (x) {
            if (x.script) {
                delete x.script.blockly;
                delete x.script.code;
                delete x.script.all;
            }
        });
    }
    function cleanTransform(t) {
        delete t.description;
        delete t.expose;
        if (!t.name) {
            delete t.name;
        }
        delete t.description;
        cleanVariables(t.variables);
        if (t.vars) {
            if (t.vars.stateScript) {
                delete t.vars.stateScript.blockly;
                delete t.vars.stateScript.all;
                delete t.vars.stateScript.code;
            }
        }
        return t;
    }
    function cleanComponent(c) {
        delete c.name;
        delete c.selected;
        delete c.description;
        delete c.isPrefab;
        delete c.depth;
        delete c.numChildren;
        delete c.closed;
        delete c.parent;
        delete c.expose;
        delete c.lastSprite;
        if (!c.disabled) {
            delete c.disabled;
        }
        if (c.script) {
            delete c.script.blockly;
            delete c.script.code;
            delete c.script.all;
        }
        // TODO: dangerous
        delete c.category;
        return c;
    }
    function cleanLink(c) {
        delete c.description;
        //delete c.meta;
        //delete c.slots;
        delete c.parent;
        delete c.selected;
        if (c.script) {
            delete c.script.blockly;
            delete c.script.code;
            delete c.script.all;
        }
        if (c.meta) {
            if (c.meta.stateScript) {
                delete c.meta.stateScript.blockly;
                delete c.meta.stateScript.code;
                delete c.meta.stateScript.all;
            }
        }
        return c;
    }
    function cleanFeature(feature) {
        var root = feature.root;
        var _a = util.getComponentsAndLinks(feature, root), links = _a.links, components = _a.components;
        var allComponents = [root].concat(components).map(function (c) {
            return c.id;
        });
        allComponents = uniq(allComponents);
        feature.components = feature.components.filter(function (x) {
            return includes(allComponents, x.id);
        });
        feature.links = feature.links.filter(function (x) {
            return includes(allComponents, x.source) && includes(allComponents, x.target);
        });
    }
    var totalLinks = 0, totalComponents = 0;
    var afterLinks = 0, afterComponents = 0;
    function cleanData(tiledata) {
        // remove components that are no longer referenced by links
        var allComponents = [];
        //(tiledata.scenes||[]).concat(tiledata.toybox||[]).forEach( (t) => {
        (tiledata.children || tiledata.transforms).forEach(function (t) {
            util.findAllComponentsFromTransforms(allComponents, [], [], tiledata, t);
        });
        allComponents = uniq(allComponents.map(function (c) { return c.id; }));
        var name = tiledata.name || tiledata.id;
        //console.log(name, '[Checking]', allComponents.length);
        //console.log(name, '[Before]', tiledata.components.length, tiledata.links.length);
        totalComponents += tiledata.components.length;
        totalLinks += tiledata.links.length;
        tiledata.components = tiledata.components.filter(function (x) {
            return includes(allComponents, x.id);
        });
        // remove links that point to no components
        tiledata.links = tiledata.links.filter(function (x) {
            return includes(allComponents, x.source) || includes(allComponents, x.target);
        });
        afterComponents += tiledata.components.length;
        afterLinks += tiledata.links.length;
        //console.log(name, '[After]', tiledata.components.length, tiledata.links.length);
    }
    function recurseTransforms(transform) {
        //cleanTransform(transform);
        (transform.transforms || transform.children).forEach(recurseTransforms);
    }
    if (data.components.length) {
      console.log(JSON.stringify(data,0,2));
        throw new Error('this game has not been converted');
    }
    //data.components = data.components.map(cleanComponent);
    data.links = data.links.map(cleanLink);
    data.features.forEach(function (feature) {
        //feature.components = feature.components.map(cleanComponent);
        feature.links = feature.links.map(cleanLink);
    });
    data.toybox.forEach(function (toy) {
        recurseTransforms(toy);
        cleanData(toy);
    });
    data.scenes.forEach(function (scene) {
        recurseTransforms(scene);
        cleanData(scene);
    });
    cleanVariables(data.variables);
    //console.log('[Total Before]', totalComponents, totalLinks);
    //console.log('[Total After]', afterComponents, afterLinks);
    cleanids(data);
    return data;
};

export default clean;
